/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Credential_Dialog_DescInputs */

const vi_einvoice_credential_dialog_desc = /** @type {(inputs: Einvoice_Credential_Dialog_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhập cùng tài khoản và mật khẩu bạn dùng để đăng nhập meInvoice, rồi bấm Kiểm tra kết nối.`)
};

/**

* @param {Einvoice_Credential_Dialog_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_credential_dialog_desc = /** @type {((inputs?: Einvoice_Credential_Dialog_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Credential_Dialog_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_credential_dialog_desc(inputs)
});